import { Link, useLocation } from 'react-router-dom';

export default function Sent() {
  const { state } = useLocation();
  const forwarded = !!state?.forwarded;
  const singleRecipient = state?.recipientName || null;
  const singleMessage = state?.message || null;
  const recipientNames = Array.isArray(state?.recipientNames) ? state.recipientNames : [];
  const messages = Array.isArray(state?.messages) ? state.messages : [];

  // Build a unified list of recipient+message pairs to recap (works for both flows).
  const recaps = forwarded
    ? recipientNames.map((name, i) => ({ name, message: messages[i] || '' }))
    : singleRecipient
    ? [{ name: singleRecipient, message: singleMessage || '' }]
    : [];

  const count = forwarded ? recipientNames.length : singleRecipient ? 1 : 0;
  const headline =
    count === 0
      ? 'On its way.'
      : count === 1
      ? `On its way to ${recaps[0].name}.`
      : `On its way to ${count} people.`;

  function shareWithFriend() {
    const url = window.location.origin;
    const text = "I just sent someone an anonymous kudo on KindKudos. Make someone\u2019s day:";
    if (navigator.share) {
      navigator.share({ title: 'KindKudos', text, url }).catch(() => {});
      return;
    }
    try {
      navigator.clipboard.writeText(`${text} ${url}`);
      alert('Link copied. Share it with a friend.');
    } catch {
      window.prompt('Copy this link:', url);
    }
  }

  return (
    <section className="mt-6 sm:mt-10 text-center">
      <div className="max-w-xl mx-auto">
        <div className="text-6xl sm:text-7xl mb-4 animate-heart inline-block">💛</div>
        <h1 className="text-3xl sm:text-4xl font-display font-bold text-navy mb-3">
          {headline}
        </h1>
        <p className="text-navy-700 mb-2 max-w-md mx-auto">
          {count > 1
            ? "They\u2019ll each get an email in the next minute or two. They won\u2019t know it came from you."
            : "They\u2019ll get an email in the next minute or two. They won\u2019t know it came from you."}
        </p>
        <p className="text-navy-500 text-sm mb-8 max-w-md mx-auto">
          That&rsquo;s the deal. What happens next is up to them.
        </p>

        {recaps.length > 0 && (
          <div className="space-y-3 text-left mb-8">
            <p className="text-xs uppercase tracking-wider text-navy-500 text-center mb-2">
              Here&rsquo;s what you sent
            </p>
            {recaps.map((r, i) => (
              <div
                key={i}
                className="rounded-2xl border border-navy/10 bg-white px-5 py-4 shadow-soft"
              >
                <p className="text-xs text-navy-500 mb-2">
                  To <strong className="text-navy">{r.name}</strong>
                  <span className="mx-2">&middot;</span>
                  From <em>someone who appreciates you</em>
                </p>
                <p className="text-navy text-[15px] leading-relaxed whitespace-pre-wrap">
                  &ldquo;{r.message}&rdquo;
                </p>
              </div>
            ))}
          </div>
        )}

        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Link to="/" className="btn-primary no-underline">
            Send another
          </Link>
          <button
            type="button"
            onClick={shareWithFriend}
            className="btn btn-ghost border border-navy/10"
          >
            Tell a friend
          </button>
        </div>
      </div>
    </section>
  );
}
